import { render, staticRenderFns } from "./saturation.vue?vue&type=template&id=2fe96aba&scoped=true&"
import script from "./saturation.vue?vue&type=script&setup=true&lang=js&"
export * from "./saturation.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./saturation.vue?vue&type=style&index=0&id=2fe96aba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fe96aba",
  null
  
)

export default component.exports